import React, { useEffect } from 'react'
import Map from '../map';
import Select from 'react-select';
import { useState } from 'react';
import { isMobile, MobileView } from 'react-device-detect';
import { useFetch } from '../../api/FetchApiData';

if (!isMobile)
    import('./partnersmap.css').then(() => {});
else
    import('./partnersmap_mob.css').then(() => {});

function PartnersMap({close=()=>{}, partner_ = null}) {

    const [partners,setPartners] = useState([]);
    const [selectedPartner, setSelectedPartner] = useState(null);
    const fetchData = useFetch();
    const [locations,setLocations] = useState([]);
    const [route, setRoute] = useState({display:false, from:[-11.472917,43.393561], to:[-11.463004,43.38916]});

    const LocationOptions = (_partners)=>
    {
        let arr = [];
        let loc_arr = [];
        _partners.map((partner)=>{
            const part = {
                value : partner.name,
                tag: partner,
                label:<div style={{display:'flex',flexDirection:'row'}}>
                        <img src='/images/icons/store.png' style={{height:'40px',borderRadius:'12px',marginRight:'10px'}} />
                        <div>
                            <label>{partner.name}</label><br/>
                            <label style={{fontSize:'x-small',color:'gray'}}>{partner.address.display_name}, Tel : 3323444</label>
                        </div>
                    </div>
            };
            arr.push(part);
            loc_arr.push(partner.address);
        });
        setPartners([...arr]);
        setLocations([...loc_arr]);
    }

    useEffect(()=>{
        fetchData.PostData({},`partners/filter/all/`).then((result)=>{
            if(result.result)
            {
                LocationOptions(result.partners)
            }
        })
    },[]);

    useEffect(()=>{
        partners.map((part)=>{
            console.log(partner_,part);
            if(!!partner_)
                if(partner_.id === part.tag.id)
                {setSelectedPartner({...part});console.log('in');}
        });   
    },[partner_, partners])

    useEffect(()=>{
        if(!!selectedPartner)
            setRoute({...route, to:[selectedPartner.tag.address.coords.latitude, selectedPartner.tag.address.coords.longitude]})
    },[selectedPartner])

    return(
    <div className='partners-map' >
        <Map OnAddMarker={()=>{}} locations={locations} routing = {route} />
        <div className='partners-map-controls'>
            <div style={{width:'60%',marginRight:'5px'}}>
                <Select options={partners} value={selectedPartner}  />
            </div>
            <input onClick={e=>{setRoute({...route,display:true})}} className='partners-map-itn' type='button'  value={'Itinéraire'} />
            <MobileView className='partners-map-itn'>
                <input onClick={e=>{close();}} style={{backgroundColor:'orangered',width:'100%'}} className='partners-map-itn' type='button' value={'Annuler'} />
            </MobileView>
        </div>
    </div>);
}

export default PartnersMap
